module.exports = {
      id: "icon-google-play-usage",
      viewBox: "0 0 12.598 13.975",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-google-play",
      toString: function () {
        return this.url;
      }
    }